export default function CallToAction() {
  return (
    <div className="call-to-action">
      <div className="call-to-action-text">
        <h3 className="call-to-action-header">Creative Harmonius Living</h3>
        <p className="call-to-action-detail">
          Gafat Products all made to standard sizes so that you can mix and
          match them freely
        </p>
        <button className="call-to-action-btn">Shop now</button>
      </div>
      <img
        src="./img/Call To Action.jpg"
        alt="Call to action"
        className="call-to-action-img"
      />
    </div>
  );
}
